export default __webpack_public_path__ + "static/annoying_bot-0915f69b73eefd78cfd388e08029852c.jpg";